<div *ngIf = "newList" mat-dialog-header>
    <h3>Create List from {{record._name}}</h3>
</div>

<div mat-dialog-content class = "list-dialog" >
    <div *ngIf = "newList">
            <input  mat-input placeholder="New List Name" [(ngModel)] = "listName" /> &nbsp; &nbsp;
            <button mat-flat-button color = "primary" (click) = "addList()" [disabled]="!listName || listName === ''">Add List</button>
    </div>
{{message}}
</div>
<div mat-dialog-actions>
    <span class = "middle-fill"></span>
    <button mat-button mat-dialog-close>Close</button>
</div>